import { loyaltyPromotionSchema } from "@redotech/redo-loyalty-common/loyalty-definition";
import * as z from "zod/v4";

export const getLoyaltyPromotions = {
  name: "getLoyaltyPromotions" as const,
  input: z.object({}),
  output: z.array(loyaltyPromotionSchema),
};
